<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col lg="5" md="5" sm="8">
          <v-card flat>
            <v-card-text>
              <div>
                <v-img
                  style="margin-left: auto; margin-right: auto"
                  width="350"
                  src="@/assets/logocentral.png"
                ></v-img>
              </div>
              <ValidationObserver ref="observer" v-slot="{ invalid }">
                <div>
                  <ValidationProvider
                    rules="required"
                    name="Employee ID"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      color="black"
                      :error-messages="errors"
                      v-model="input.username"
                      label="Employee ID / รหัสพนักงาน"
                      append-icon="mdi-account-circle-outline"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    name="Identity ID (last 4 digits)"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      type="password"
                      color="black"
                      :error-messages="errors"
                      v-model="input.password"
                      label="Identity ID (last 4 digits) / รหัสบัตรประชาชน 4 ตัวท้าย"
                      append-icon="mdi-lock-outline"
                    ></v-text-field>
                  </ValidationProvider>
                </div>
                <div class="text-center">
                  <v-btn
                    @click="login"
                    :disabled="invalid"
                    large
                    :loading="loading"
                    color="#E91F27"
                    class="mt-2"
                    block
                    style="border-radius: 0px; color: white"
                    >LOGIN</v-btn
                  >
                </div>
              </ValidationObserver>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <div>
        <v-dialog fullscreen v-model="term">
          <v-card> <Term @close="term = false"></Term> </v-card>
        </v-dialog>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import mobile from "is-mobile";
import Term from "./Term.vue";
export default {
  components: {
    Term,
  },
  data() {
    return {
      term: true,
      loading: false,
      input: {
        username: "",
        password: "",
      },
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  methods: {
    login() {
      var vm = this;
      var isValid = this.$refs.observer.validate();
      if (isValid) {
        vm.loading = true;
        var data = {
          userid: vm.profile.userId + "__" + vm.query.pageid,
          pageid: vm.query.pageid,
          employee_id: vm.input.username,
          employee_identity_id: vm.input.password,
        };
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/centralhrlogin",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxxx xxx",
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              if (mobile()) {
                await this.$swal.fire({
                  icon: "success",
                  text: "Success",
                });
              }
              if (this.query.apptype == "line") {
                if (mobile()) {
                  await this.$liff.sendMessages([
                    {
                      type: "text",
                      text: "เข้าสู่ระบบสำเร็จ",
                    },
                  ]);
                  vm.loading = false;
                } else {
                  await vm.$swal.fire({
                    icon: "success",
                    text: 'เข้าสู่ระบบสำเร็จ กรุณาพิมพ์ "เมนูหลัก" เพื่อใช้งาน',
                  });
                  vm.loading = false;
                }
                await this.$liff.closeWindow();
              }
            } else {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
            }
            vm.loading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>